import { FC } from 'react';
import { isEmpty, get } from 'lodash';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { translate } from 'containers/services/translate';
import { injectIntl, IntlShape } from 'react-intl';
import {
  StyledPaper,
  StyledTitleTypography,
  StyledFlex,
} from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/style';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { getVictimFromSagisInfo } from 'containers/PreOpeningPage/utils';
import { getVehicleFromSagisInfo } from 'containers/PreOpeningPage/OpposingParty/utils';
import { VictimType } from 'typings/globalTypes';

interface DamageAffectedByTheProcedureProps {
  intl: IntlShape;
  info: any;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
}

const DamageAffectedByTheProcedure: FC<DamageAffectedByTheProcedureProps> = props => {
  const { otherDamage = [], victims = [], vehicules = [] } = props.info;

  const listVictims = () => {
    return victims.map((victim: VictimType) => (
      <StyledPaper elevation={1}>
        {featureService.hasFeature(FEATURES.MIGRATION_CLAIM_INFO) &&
        !isEmpty(
          getVictimFromSagisInfo(
            get(victim, 'victimKey'),
            props.sagisVictimInfo,
          ),
        )
          ? `${get(
              getVictimFromSagisInfo(
                get(victim, 'victimKey'),
                props.sagisVictimInfo,
              ),
              'victimFirstName',
              '',
            )} ${get(
              getVictimFromSagisInfo(
                get(victim, 'victimKey'),
                props.sagisVictimInfo,
              ),
              'victimLastName',
              '',
            )}`
          : `${victim.firstName} ${victim.lastName}`}
      </StyledPaper>
    ));
  };

  const listVehicles = () => {
    return vehicules.map((vehicule: any) => (
      <StyledPaper elevation={1}>
        {featureService.hasFeature(FEATURES.MIGRATION_CLAIM_INFO) &&
        !isEmpty(
          getVehicleFromSagisInfo(
            get(vehicule, 'partKey'),
            props.sagisOpposingParties,
          ),
        )
          ? get(
              getVehicleFromSagisInfo(
                get(vehicule, 'partKey'),
                props.sagisOpposingParties,
              ),
              'lastName',
            ) +
            ' ' +
            get(
              getVehicleFromSagisInfo(
                get(vehicule, 'partKey'),
                props.sagisOpposingParties,
              ),
              'firstName',
            )
          : `${vehicule.firstName} ${vehicule.lastName}`}
      </StyledPaper>
    ));
  };
  const listOtherDamage = () =>
    otherDamage.map((otherDamageItem: any) => (
      <StyledPaper elevation={1}>{otherDamageItem.description}</StyledPaper>
    ));

  return (
    <div>
      {victims.length > 0 && (
        <StyledTitleTypography>
          {translate(messages.victims, props)}
        </StyledTitleTypography>
      )}
      <StyledFlex>{listVictims()}</StyledFlex>
      {vehicules.length > 0 && (
        <StyledTitleTypography>
          {translate(messages.vehicles, props)}
        </StyledTitleTypography>
      )}
      <StyledFlex>{listVehicles()}</StyledFlex>
      {otherDamage.length > 0 && (
        <StyledTitleTypography>
          {translate(messages.otherProperties, props)}
        </StyledTitleTypography>
      )}
      <StyledFlex>{listOtherDamage()}</StyledFlex>
    </div>
  );
};

export default injectIntl(DamageAffectedByTheProcedure);
